export default {
  url: 'integrator-4795701.okta.com',
  issuer: 'https://integrator-4795701.okta.com/oauth2/default',
  redirect_uri: window.location.origin + '/implicit/callback',
  client_id: process.env.REACT_APP_AUTHPROVIDERCID || '0oa17fkj7e4yxW4RU698',
  recaptcha_site_key: process.env.REACT_APP_REAPTCHASITEKEY || '6LeuebUtAAAAAMAW-259JypLxASPYwm87IEZ6Tb9',
  // AWS Lex Config (Aligning with libhacontimig Android implementation)
  lexBotId: process.env.REACT_APP_LEX_BOT_ID || 'HealthDashSupportBot',
  lexBotAliasId: process.env.REACT_APP_LEX_BOT_ALIAS_ID || 'PROD',
  lexLocaleId: 'en_US'
}